import { writable } from "svelte/store"

/**
 * Config Store
 *
 * Configuration values come from 2 sources,
 *
 * 1) standalone app development / svelte only context
 *    - source app/.env
 *    - configuration values are loaded by dotenv in rollup.config.js
 *    - the uppercase strings in the `defaults` var below are replaced by rollup.config.js
 *
 * 2) Wordpress Plugin Context
 *    - script is localized by wp_localize_script()
 *    - values are loaded in app/main.js
 *    - default values are overriden in app/main.js by passing in the config object
 * window.gremConfig and calling config.fromWordpress()
 */
const defaults = {
	debug: false,
	locations: [],
}

const createConfigStore = () => {

	const { subscribe, set, update } = writable( { ...defaults } )

	const fromWordpress = values =>
		update( config => {
			config = { ...config, ...values }
			return config
		} )

	return {
		subscribe,
		set,
		update,
		fromWordpress,
	}
}

export const config = createConfigStore()
